<template>
  <div>
    <div style="background-color: lightgrey">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" title="查询条件">
          <van-cell title="开始时间" :value="queryFormModel.startTime" is-link @click="showDatetimePickerPopup('start')"
                    style="background: #fff;"/>
          <van-cell title="结束时间" :value="queryFormModel.endTime" is-link @click="showDatetimePickerPopup('end')"
                    style="background: #fff;"/>
          <div class="flex justify-center margin-tb-xs">
            <van-button size="large" type="info" @click="loadData(true)">查询</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-if="current != null&&current.groupId!=3590" >
      <van-cell-group v-if="isCustomColumns" style="margin-top: 20px;">
        <van-cell title="店员名称" :value="current.name"/>
        <van-cell :title="$store.state.shop.id == 8 ? '公会' : '组名'" :value="current.groupName"/>
        <van-cell title="等级" :value="$store.state.ClerkGradeMap[current.grade]"/>
        <van-cell title="在线时长" :value="formatTime(current.onLineDuration)"/>
        <template  v-if="![1,47].includes($store.state.shop.id)">
        <van-cell  v-for="(item, index) in tableColumns" :key="index" :title="item.title">
          <span :class="current[item.key].includes('￥')?'text-red text-bold text-lg':''">{{ current[item.key]}}</span>
        </van-cell>
        </template>
        <div v-else  v-for="(item, index) in tableColumns" :key="index" >
          <van-cell v-if="!['orderCount','firstCount','continuedCount','firstAmount','continuedAmount',].includes(item.expression)" :title="item.title">
            <span :class="current[item.key].includes('￥')?'text-red text-bold text-lg':''">{{ current[item.key]}}</span>
          </van-cell>
          <template v-else>
            <van-collapse v-model="userLevelNames" >
              <van-collapse-item :title="item.title" :name="index" :value="current[item.key]" class="levelData" :class="['firstAmount','continuedAmount'].includes(item.expression)?'redColor':''">
                <van-cell v-for="(item2,index) of userLevelList" :key="index" :title="`${item.title}(${$store.state.UserGradeMap[item2.userLevel]|| '无'})`" :value="userLevelFieldData47(item.expression,item2)||0"/>
              </van-collapse-item>
            </van-collapse>
          </template>
        </div>
      </van-cell-group>
      <van-cell-group v-if="!isCustomColumns" style="margin-top: 20px;">
        <van-cell title="店员名称" :value="current.name"/>
        <van-cell :title="$store.state.shop.id == 8 ? '公会' : '组名'" :value="current.groupName"/>
        <van-cell title="等级" :value="$store.state.ClerkGradeMap[current.grade]"/>
        <van-cell title="订单数" :value="current.orderCount"/>
        <van-cell title="首单数" :value="current.firstCount"/>
        <van-cell title="续单数" :value="current.continuedCount"/>
        <van-cell title="退款单数" :value="current.refundedCount"/>
        <van-cell title="接单超时数" :value="current.confirmTimeoutOrderCount"/>
        <van-cell title="订单金额">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.orderAmount) }}</span>
        </van-cell>
        <van-cell title="首单金额">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.firstAmount) }}</span>
        </van-cell>
        <van-cell title="续单金额">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.continuedAmount) }}</span>
        </van-cell>
        <van-cell title="打赏金额">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.rewardAmount) }}</span>
        </van-cell>
        <van-cell v-if="$store.state.shop.id === 2362" title="实际流水">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.actualIncome?current.actualIncome:0) }}</span>
        </van-cell>
        <van-cell v-else title="实付金额">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.actualPayAmount?current.actualPayAmount:0) }}</span>
        </van-cell>
        <van-cell title="退款金额">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.refundedAmount) }}</span>
        </van-cell>
        <van-cell title="用户数" :value="current.userCount"/>
        <van-cell title="续单用户数" :value="current.continuedUserCount"/>
        <van-cell title="续单率" :value="calContinuedPercent(current.continuedCount, current.orderCount)+'%'"/>
        <van-cell title="续费率" :value="calContinuedFeePercent(current.continuedAmount, current.orderAmount)+'%'"/>
        <van-cell title="退单率" :value="refundPercent(current.refundedCount,current.totalOrderCount) +'%'"/>
        <van-cell title="续客率" :value="continueUserPercent(current.continuedUserCount,current.userCount) +'%'"/>
        <van-cell title="客单价">
          <span class="text-red text-bold text-lg text-price" >{{ userPricePercent(current.actualPayAmount,current.userCount) }}</span>
        </van-cell>

        <van-cell title="外部订单数" v-if="$hasFeature('out_order')" :value="current.outOrderCount"/>
        <van-cell title="外部订单总额" v-if="$hasFeature('out_order')">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.outOrderTotalAmount) }}</span>
        </van-cell>
        <van-cell title="外部订单工资" v-if="$hasFeature('out_order')">
          <span class="text-red text-bold text-lg text-price">{{ formatPrice(current.outOrderClerkWages) }}</span>
        </van-cell>
        <van-cell title="工资" :value="formatPrice(current.clerkWagesAmount)"/>
        <van-cell title="在线时长" :value="formatTime(current.onLineDuration)"/>
      </van-cell-group>
      <!--          <van-cell title="续客率（续单用户数/用户数）" style="white-space: nowrap" :value="getContinuedUserPercent()" />-->
    </div>
    <div v-if="current != null&&current.groupId==3590">
    <van-cell-group  style="margin-top: 20px;">
        <van-cell title="店员名称" :value="current.name"/>
        <van-cell :title="$store.state.shop.id == 8 ? '公会' : '组名'" :value="current.groupName"/>
        <van-cell title="贡献值" :value="formatPrice(current.continuedAmount)-(formatPrice(current.firstAmount)*1.5)"/>
      </van-cell-group>
    </div>

    <!-- 选择日期 -->
    <van-popup
        v-model="datetimePickerPopupShow"
        class="datetime-picker-popup"
        position="bottom"
    >
      <van-datetime-picker
          v-model="datetimePicker.value"
          type="date"
          :max-date="datetimePicker.maxDate"
          :formatter="datetimePickerFormatter"
          @confirm="datetimePickerConfirm"
          @cancel="datetimePickerPopupShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Tab, Tabs, List, Toast, Dialog, Collapse, CollapseItem, Popup,Button, DatetimePicker} from 'vant';
import Decimal from 'decimal.js';
import moment from 'moment';
import {statisticsClerkOrder} from '@/api/clerk/order'
import { getTable } from '@/api/custom_table'

Vue.use(Cell)
    .use(CellGroup)
    .use(Tab)
    .use(Tabs)
    .use(List)
    .use(Toast)
    .use(Dialog)
    .use(Collapse)
    .use(CollapseItem)
    .use(Popup)
    .use(DatetimePicker)
    .use(Button)


export default {
  name: 'wages',
  data() {
    return {
      activeNames: [1],
      queryFormModel: {
        sex: null,
        group: null,
        isDisabled: null,
        startTime: moment().subtract(1, 'weeks').format('YYYY-MM-DD'),
        endTime: moment().subtract(1, 'days').format('YYYY-MM-DD')
      },
      datetimePicker: {
        field: null,
        value: null,
        maxDate: moment().add('3', 'month').toDate()
      },
      datetimePickerPopupShow: false,
      activceTab: 'current',
      current: [],
      userLevelNames:[],
      userLevelList: [],
      unsettled: null,
      history: {
        loading: false,
        listFinished: false,
        list: [],
        pageNo: 1,
        pageSize: 20
      },
      isCustomColumns:false,
      tableColumns:[],
    }
  },
  methods: {
    userLevelFieldData47(expression,item){
      if (expression=='orderCount'){
        return item.orderCount
      }else if (expression=='firstCount'){
        return item.firstCount
      }else if (expression=='continuedCount'){
        return item.continuedCount
      }else if (expression=='firstAmount'){
        return '￥'+this.formatPrice(item.firstAmount)
      }else if (expression=='continuedAmount'){
        return '￥'+this.formatPrice(item.continuedAmount)
      }
      return 0
    },
    datetimePickerFormatter(field, value) {
      if (field === 'year') {
        return `${value}年`;
      } else if (field === 'month') {
        return `${value}月`
      } else if (field == 'day') {
        return `${value}日`
      }
      return value;
    },
    showDatetimePickerPopup(field) {
      this.datetimePicker.field = field
      if (field == 'start') {
        this.datetimePicker.value = moment(this.queryFormModel.startTime).toDate()
      } else if (field == 'end') {
        this.datetimePicker.value = moment(this.queryFormModel.endTime).toDate()
      }
      this.datetimePickerPopupShow = true;
    },
    datetimePickerConfirm(value) {
      this.datetimePickerPopupShow = false;
      if (this.datetimePicker.field == 'start') {
        this.queryFormModel.startTime = moment(value).format('YYYY-MM-DD');
      } else if (this.datetimePicker.field == 'end') {
        this.queryFormModel.endTime = moment(value).format('YYYY-MM-DD');
      }
    },
    // 计算续单率
    calContinuedPercent(count, continuedCount) {
      if (count == undefined || continuedCount == undefined) return
      var result = Decimal.mul(Decimal.div(count, continuedCount), 100).toFixed(2)
      return !isNaN(result) ? result : 0
    },
    calContinuedFeePercent(continuedFeeAmount,orderAmount) {
      if (orderAmount == undefined || continuedFeeAmount == undefined) return
      let result = Decimal.mul(Decimal.div(continuedFeeAmount, orderAmount), 100).toFixed(2)
      return !isNaN(result) ? result : 0
    },
    refundPercent(refundedCount, totalOrderCount) {
      if (refundedCount == undefined || totalOrderCount == undefined) return
      let result = Decimal.mul(Decimal.div(refundedCount, totalOrderCount), 100).toFixed(2)
      return !isNaN(result) ? result : 0
    },
    continueUserPercent(continuedUserCount, userCount) {
      if (continuedUserCount == undefined || userCount == undefined) return
      let result = Decimal.mul(Decimal.div(continuedUserCount, userCount), 100).toFixed(2)
      return !isNaN(result) ? result : 0
    },
    userPricePercent(actualPayAmount, userCount) {
      if (actualPayAmount == undefined || userCount == undefined) return
      let result = Decimal.div(Decimal.div(actualPayAmount, userCount), 100).toFixed(2)
      return !isNaN(result) ? result : 0
    },
    formatTime(stamp) {
      // 转换为时间段
      stamp = stamp / 1000
      let str = ''
      let d = stamp / 86400
      if (d >= 1) {
        str += Math.floor(d) + '天'
        stamp = stamp - 86400 * Math.floor(d)
      }
      let h = stamp / 3600
      if (h >= 1) {
        str += Math.floor(h) + '小时'
        stamp = stamp - 3600 * Math.floor(h)
      }
      let m = stamp / 60
      if (m >= 1) {
        str += Math.floor(m) + '分钟'
      }
      if (str == '') {
        return 0
      }
      return str
    },
    getContinuedPercent() {
      if (this.current.orderCount) {
        return Decimal.mul(Decimal.div(this.current.continuedCount, this.current.orderCount), 100).toFixed(2) + '%';
      }
      return '0%'
    },
    getContinuedUserPercent() {
      if (this.current.userCount != 0 && this.current.continuedUserCount != 0) {
        return Decimal.mul(Decimal.div(this.current.continuedUserCount, this.current.userCount), 100).toFixed(2) + '%';
      }
      return '0%'
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    getTable(){
      getTable('statistics-clerk-order').then((res) => {
        const data = res.data
        if (data.code == 0) {
          let tableColumns = data.tableColumns
          if (tableColumns != null && tableColumns.length != 0){
            this.tableColumns=tableColumns
            this.isCustomColumns=true;
          }else {
            this.isCustomColumns=false;
          }
        }
      })
    },
    loadData() {
      Toast.loading({
        overlay: true,
        message: '加载中...'
      })
      this.current = null
      statisticsClerkOrder(
          this.queryFormModel.startTime,
          this.queryFormModel.endTime).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.current = data.list;
          this.userLevelList = data.userLevelList;
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
  },
  activated () {
    this.getTable()
  },
  mounted() {
    this.loadData()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.history-wages-list {
  .amount {
    flex: none;
  }
}
/deep/ .redColor .van-cell .van-cell__value span{
  font-weight: bold;
  color: var(--red);
}
/deep/ .levelData .van-collapse-item__content {
  padding: 0px 20px 0px 0px;
}

</style>
